// constants 
export const RESET_ERROR = "RESET_ERROR";
export const ERROR_OCCURED = "ERROR_OCCURED";
export const NETWORK_ERROR_OCCURED = "NETWORK_ERROR_OCCURED";

export interface ErrState {
  error: boolean,
  errorData: ErrorDataType
}

export interface ErrorDataType {
  type: string;
  body: string;
  networkError: string;
  err: ErrResponseType
};


export interface ErrResponseType {
  status: any;
  error: {
    status: boolean,
    statusMessage: string,
    errorType: string,
  },
  type: string
}

// Action types
export interface ResetErrorAction {
  type: typeof RESET_ERROR
}
export interface NetworkErrorAction {
  type: typeof NETWORK_ERROR_OCCURED,
  err: ErrResponseType
}
export interface DataErrorAction {
  type: typeof ERROR_OCCURED,
  err: ErrResponseType
}
export type ErrActionTypes = ResetErrorAction | NetworkErrorAction | DataErrorAction;